import React, { useEffect, useRef } from "react";

/*
 * Fixed gradient sky behind the 3D scene. Colors interpolate with
 * scroll so the page moves from dusk pink → sunset → violet → night
 * as one continuous shot instead of hard section backgrounds.
 */

const SKY = [
  ["#d777ac", "#edc3ab"], // hero: dusk pink
  ["#5a1030", "#b06a45"], // about: deep sunset
  ["#341347", "#150b28"], // projects: violet dusk
  ["#22030f", "#050207"], // contact: night
];

const hexToRgb = (hex) => [
  parseInt(hex.slice(1, 3), 16),
  parseInt(hex.slice(3, 5), 16),
  parseInt(hex.slice(5, 7), 16),
];

const mix = (a, b, t) =>
  `rgb(${a.map((v, i) => Math.round(v + (b[i] - v) * t)).join(",")})`;

const STOPS = SKY.map((pair) => pair.map(hexToRgb));

const Backdrop = () => {
  const ref = useRef(null);

  useEffect(() => {
    let raf = null;

    const paint = () => {
      raf = null;
      const el = ref.current;
      if (!el) return;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const p = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
      const f = p * (STOPS.length - 1);
      const i = Math.min(Math.floor(f), STOPS.length - 2);
      const t = f - i;
      const top = mix(STOPS[i][0], STOPS[i + 1][0], t);
      const bottom = mix(STOPS[i][1], STOPS[i + 1][1], t);
      el.style.background = `linear-gradient(to bottom, ${top}, ${bottom})`;
    };

    const onScroll = () => {
      if (raf === null) raf = requestAnimationFrame(paint);
    };

    paint();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      if (raf !== null) cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return <div ref={ref} className="fixed inset-0 -z-10" aria-hidden="true" />;
};

export default Backdrop;
